<div class="modal-dialog modal-dialog-scrollable m-0 scrollable-dialog">
    <form class="kt-form w-webkit-fill-available" [formGroup]="form">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Settlement Settings</h5>
                <span class="modal-x-button" (click)="onCloseDialog()"><i class="fa fa-times" aria-hidden="true"></i></span>
            </div>
            <div class="modal-body">
                <div class="col-md-12 form-group row">
                    <label class="col-3 col-form-label">Active Member Valid Turnover<span class="text-danger">*</span></label>
                    <input type="number" formControlName="active_member_valid_turnover" class="col-5 form-control">
                    <span class="col-4 col-form-label">Members only considered as active members when their valid turnover exceed this amount. Default is 0</span>
                </div>
                <div class="col-12 form-group row">
                    <label class="col-3 col-form-label">Active Member Minimum Deposit<span class="text-danger">*</span></label>
                    <input type="number" formControlName="active_member_minimum_deposit" class="col-5 form-control">
                    <span class="col-4 col-form-label">Members only considered as active members when their deposit exceed this amount. Default is 0</span>
                </div>
                <div class="col-12 form-group row">
                    <label class="col-3 col-form-label">Total Commission Active Members<span class="text-danger">*</span></label>
                    <input type="number" formControlName="total_commission_active_member" class="col-5 form-control">
                    <span class="col-4 col-form-label">The required number of active members when calculate commission by total win loss amount</span>
                </div>
                <div class="col-12 form-group row">
                    <label class="col-3 col-form-label">Deposit Transaction Fee Rate (%)<span class="text-danger">*</span></label>
                    <input type="number" formControlName="deposit_transaction_fee_rate" class="col-5 form-control">
                    <span class="col-4 col-form-label">The fee rate of total amount deposit by members under affiliate</span>
                </div>
                <div class="col-12 form-group row">
                    <label class="col-3 col-form-label">Withdrawal Transaction Fee Rate (%)<span class="text-danger">*</span></label>
                    <input type="number" formControlName="withdrawal_transaction_fee_rate" class="col-5 form-control">
                    <span class="col-4 col-form-label">The fee rate of total amount withdraw by members under affiliate</span>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="onCloseDialog()"><i class="fas fa-ban"></i>Close</button>
                <kt-submit-button [isDisabled]="!form.valid" [buttonLoading]="buttonLoading" (confirmed)="onSave()"></kt-submit-button>
            </div>
        </div>
    </form>
</div>

<kt-swal-alert [message]="messages$ | async" (confirmed)="onCloseDialog(true)"></kt-swal-alert>